// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleLayout_container__1PGJc","simpleLayout":"SimpleLayout_simpleLayout__OMqIy"};